import React from 'react';
import styled from 'styled-components';
import Visitor from '../../components/layouts/Visitor';
import HeaderOne from '../../components/parts/HeaderOne';
import SignUpForm from '../../components/combinations/SignUpForm';
import LinkText from '../../components/parts/LinkText';
import UserHead from "../../config/UserHead";

const SignUpStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const ToLoginPageStyle = styled(LinkText)`
  text-align: center;
  text-decoration: underline;
`;

const SignUp: React.FC = (() => {

  return (
    <Visitor>
      <UserHead title='新規登録' />
      <SignUpStyle>
        <HeaderOneStyle>新規登録</HeaderOneStyle>
        <SignUpForm />
        <ToLoginPageStyle href='/user/login'>会員の方はこちら</ToLoginPageStyle>
      </SignUpStyle>
    </Visitor>
  );
});
export default SignUp;
